import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { MonitoramentoChecklistEmpresa } from "../../../../obras/domain/models/monitoramento_checklist_empresa";
import { MonitoramentoChecklistFuncionario } from "../../../../obras/domain/models/monitoramento_checklist_funcionario";
import { IGetReportMonitoramentoChecklistUseCase } from "../../../presentation/useCases/read/get_report_monitoramento_checklist_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportMonitoramentoChecklistUseCase
 */

export class GetReportMonitoramentoChecklistUseCase implements IGetReportMonitoramentoChecklistUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportMonitoramentoChecklist(
    idObra: number,
    idUsuario: number,
    area: number[] | null,
    statusArea: number[] | null,
    servico: number[] | null,
    statusServico: number[] | null,
    dataAberturaDe: Date | null,
    dataAberturaAte: Date | null,
    dataEncerramentoDe: Date | null,
    dataEncerramentoAte: Date | null,
    statusVerificacao: number[] | null,
    statusItemChecklist: number[] | null,
    empresaTercerizadas: number[] | null,
    funcionarios: number[] | null,
    requiredMimeType: ReportMimeType | null,
    monitoramentoChecklistEmpresaDropDown: MonitoramentoChecklistEmpresa[],
    monitoramentoChecklistFuncionarioDropDown: MonitoramentoChecklistFuncionario[],
  ): Promise<ReportData> {

    const areaStr = area ? area.filter(x => x !== 0).join(',') : null;
    const statusAreaStr = statusArea ? statusArea.filter(x => x !== 4).join(',') : null;
    const servicoStr = servico ? servico.filter(x => x !== 0).join(',') : null;
    const statusServicoStr = statusServico ? statusServico.filter(x => x !== 4).join(',') : null;
    const statusVerificacaoStr = statusVerificacao ? statusVerificacao.filter(x => x !== 4).join(',') : null;

    const finalEmpresaTercerizadas = this.computeEmpresaTerceirizadas(
      empresaTercerizadas, monitoramentoChecklistEmpresaDropDown);

    const finalFuncionarios = this.computeFuncionarios(
      funcionarios, monitoramentoChecklistFuncionarioDropDown);

    let statusItemChecklistStr: string | null = null;

    if (statusItemChecklist && statusItemChecklist.length > 0) {
      statusItemChecklistStr = '';
      statusItemChecklist?.forEach(x => {
        switch (x) {
          case 0:
            statusItemChecklistStr += 'N,';
            break;
          case 1:
            statusItemChecklistStr += 'X,';
            break;
          case 2:
            statusItemChecklistStr += 'A,';
            break;
          case 3:
            statusItemChecklistStr += 'R,';
            break;
        }
      });
    }

    const response = await this.repository.getReportMonitoramentoChecklist(
      idObra,
      idUsuario,
      areaStr,
      statusAreaStr,
      servicoStr,
      statusServicoStr,
      dataAberturaDe,
      dataAberturaAte,
      dataEncerramentoDe,
      dataEncerramentoAte,
      statusVerificacaoStr,
      statusItemChecklistStr,
      finalEmpresaTercerizadas?.join(',') ?? null,
      finalFuncionarios?.join(',') ?? null,
      requiredMimeType,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `monitoramento_checklist_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }

  computeEmpresaTerceirizadas(
    empresaTercerizadas: number[] | null,
    monitoramentoChecklistEmpresaDropDown: MonitoramentoChecklistEmpresa[],
  ): string[] | null {
    if (empresaTercerizadas === null || empresaTercerizadas.length < 1 || monitoramentoChecklistEmpresaDropDown.length < 1) return null;
    return monitoramentoChecklistEmpresaDropDown
      .filter(x => empresaTercerizadas.includes(x.id))
      .map(x => `${x.tipo}:${x.id}`);
  }

  computeFuncionarios(
    funcionarios: number[] | null,
    monitoramentoChecklistFuncionarioDropDown: MonitoramentoChecklistFuncionario[],
  ): string[] | null {
    if (funcionarios === null || funcionarios.length < 1 || monitoramentoChecklistFuncionarioDropDown.length < 1) return null;
    return monitoramentoChecklistFuncionarioDropDown
      .filter(x => funcionarios.includes(x.id))
      .map(x => `${x.tipo}:${x.id}`);
  }
}
